import React from 'react';

export const RecordIcon = ({height = 64, width = 64, fill = "#ff2600",  ...props}) => {
    return (
        <svg fill={fill} height={height} width={width} version="1.1" id="Capa_1" viewBox="-4 -4 47.99 47.99" {...props}>
            <g id="SVGRepo_bgCarrier" strokeWidth="0">
                <rect x="-4" y="-4" width="47.99" height="47.99" rx="23.995" fill={fill} strokeWidth="0"></rect>
            </g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path id="XMLID_155_" d="M19.994,0C8.952,0,0,8.952,0,19.995c0,11.043,8.952,19.994,19.994,19.994s19.995-8.952,19.995-19.994 C39.989,8.952,31.037,0,19.994,0z M19.994,27.745c-4.28,0-7.75-3.47-7.75-7.75s3.47-7.75,7.75-7.75s7.75,3.47,7.75,7.75 S24.275,27.745,19.994,27.745z"></path>
            </g>
        </svg>
    )
};